"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    priceList: 'Prislista' || 'priceList',
    addArticle: 'Lägg till artikel till prislista' || 'addArticle',
    addCustomerSubUnit: 'Lägg till kund till prislista' || 'addCustomerSubUnit',
    addSupplierCustomer: 'Lägg till kund till prislista' || 'addSupplierCustomer',
    removeSupplierCustomer: 'Ta bort kund från prislista' || 'removeSupplierCustomer',
    moveSupplierCustomer: 'Ta bort kund från alla prislistor och lägg till i ny' ||
        'moveSupplierCustomer',
    writePriceList: 'Uppdatera prislista' || 'writePriceList',
    writePriceListFast: 'Uppdatera prislista' || 'writePriceListFast',
    deactivate: 'Inaktivera prislista' || 'deactivate',
    activate: 'Aktivera prislista' || 'activate',
    setOwningSupplierOrganization: 'Sätt ägande organisation' || 'setOwningSupplierOrganization',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    name: 'Namn på prislista' || 'name',
    currency: 'Valuta' || 'currency',
    supplier: 'Leverantör' || 'supplier',
    active: 'Aktiverad' || 'active',
    chain: 'Kedja' || 'chain',
    isApprovedByChain: 'Godkänd av kedja' || 'isApprovedByChain',
    customerType: 'Kundtyp' || 'customerType',
    customerTypes: {
        horeca: 'HoReCa' || 'horeca',
        dvh: 'Dagligvaruhandel' || 'dvh',
        wholesale: 'Grossist' || 'wholesale',
        office: 'Kontor' || 'office',
        systembolaget: 'Systembolaget' || 'systembolaget',
        supplier: 'Leverantör till Flaivy' || 'supplier',
        export: 'Export' || 'export',
        other: 'Övrigt' || 'other',
    },
    discountOnAllArticles: 'Procentrabatt på alla artiklar' || 'discountOnAllArticles',
    activeFrom: 'Aktiv från' || 'activeFrom',
    activeTo: 'Aktiv till' || 'activeTo',
    priceType: 'Pristyp' || 'priceType',
    priceTypes: {
        campaign: 'Kampanj' || 'campaign',
        tender: 'Anbud' || 'tender',
        tenderCampaign: 'Anbud och kampanj' || 'tenderCampaign',
    },
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    discountAgreements: {
        id: 'Identitet' || 'id',
        customerSubUnit: 'Kund' || 'customerSubUnit',
        supplierCustomer: 'Leverantörskund' || 'supplierCustomer',
        isApprovedByCustomerSubUnit: 'Godkänd av kund' || 'isApprovedByCustomerSubUnit',
    },
    priceListEntries: {
        id: 'Identitet' || 'id',
        article: 'Artikel' || 'article',
        price: 'Försäljningspris per styck/kg (exkl. eventuell pant)' || 'price',
        discount: 'Procentrabatt' || 'discount',
        priceType: 'Pristyp' || 'priceType',
        priceTypes: {
            campaign: 'Kampanj' || 'campaign',
            tender: 'Anbud' || 'tender',
            tenderCampaign: 'Anbud och kampanj' || 'tenderCampaign',
        },
    },
};
